module.exports = __webpack_public_path__ + "img/5.094b4adf.png";